// extracted by mini-css-extract-plugin
module.exports = {"map":"worldMap_map__3dc2u"};